import * as React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
  hasSuccess?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError, hasSuccess, disabled, ...props }, ref) => (
    <input
      ref={ref}
      disabled={disabled}
      className={cn(
        'w-full rounded-xl border bg-white px-3.5 py-2.5 text-sm text-gray-900 transition-all',
        'placeholder:text-gray-400',
        'focus:outline-none focus:ring-2',
        'disabled:cursor-not-allowed disabled:opacity-40 disabled:bg-gray-100',
        hasError
          ? 'border-error-400 focus:border-error-500 focus:ring-error-100'
          : hasSuccess
            ? 'border-success-500 focus:border-success-500 focus:ring-success-500/20'
            : 'border-gray-300 hover:border-gray-400 focus:border-brand-400 focus:ring-brand-100',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
